import {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog22/image1 Trusk-gate returns.png";
import image2 from "../../../../assets/images/blog22/image2 Trump US hot.png";
import image3 from "../../../../assets/images/blog22/image3 china rare earths.png";
import image6 from "../../../../assets/images/blog22/image6 hedgieslov etech now.png";
import image8 from "../../../../assets/images/blog22/image8 Vix and Move back in the calm zone.png";
import image16 from "../../../../assets/images/blog22/image16 bullish naratives.png";
import image17 from "../../../../assets/images/blog22/image17 ample liquidity.png";
import image18 from "../../../../assets/images/blog22/image18 flows.png";
import image30 from "../../../../assets/images/blog22/image30 gold follows global debt.png";
import image32 from "../../../../assets/images/blog22/image32 undeclared gold.png";
import image33 from "../../../../assets/images/blog22/image33 GOLD SILVER RATIO moving.png";
import image34 from "../../../../assets/images/blog22/image34 JPM loves BTC.png";
import image35 from "../../../../assets/images/blog22/image35 OIL range high.png";
import image36 from "../../../../assets/images/blog22/image36 GDPNow post ISM Services and trade.png";
import image40 from "../../../../assets/images/blog22/image40 AI big contributor to GDP.png";
import image41 from "../../../../assets/images/blog22/image41 where is the stagflation surprise.png";
import image42 from "../../../../assets/images/blog22/image42 inflation danger.png";
import image43 from "../../../../assets/images/blog22/image43 US house demand crash.png";
import image44 from "../../../../assets/images/blog22/image44 CB cutting hard.png";
import image59 from "../../../../assets/images/blog22/image59 SPX 6k .png";
import image66 from "../../../../assets/images/blog22/image66 NFP details.png";

import BlogImagePopper from "./BlogImageLarge";

const Blog22 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – June 9, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Trump, Tariffs & Tactical Breadth: Rally Expands But CPI Could Reverse It
        </p>
        <p>
          Markets delivered another strong week across major indices. S&P 500, Dow, and Russell 2000 all hit 3.5-month highs, with the Russell logging its best week since February. But behind the
          headlines, a wave of positioning flows, not macro fundamentals, powered the breakout. This week’s CPI, PPI, and trade talks will decide whether this is a true expansion or the last leg of
          the chase.
        </p>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: “Breadth Breaks Out, But Liquidity Still Drives”</p>
              <p>The rally broadened meaningfully. Market internals show the best momentum across timeframes since March:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>71.23% of SPX above 5-day MA</p>
                </li>
                <li className="themesPointer">
                  <p>72.61% above 50-day</p>
                </li>
                <li className="themesPointer">
                  <p>60.71% above 20-day</p>
                </li>
                <li className="themesPointer">
                  <p>56.54% above 100-day</p>
                </li>
                <li className="themesPointer">
                  <p>49.20% above 200-day</p>
                </li>
                <li className="themesPointer">
                  <p>5-day highs outnumbered lows 4:1</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image16}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image16)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>VIX is sub-18, MOVE back below 100. The market is pricing in calm despite headline landmines on tariffs and inflation.</p>
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>Flows are forcing the tape higher: CTAs are long, hedge funds returned midweek after fading the early rally, and mutual funds remain underweight.</p>
              <div className="relatedImg">
                <img
                  src={image18}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image18)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Rare earth optimism (China resumed shipments) and MAG7 rotation helped, but this is more about flow mechanics and sentiment reset than hard data.</p>
              <div className="relatedImg">
                <img
                  src={image3}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: “Cut Parade Continues, But Services Are Cracking”</p>
              <p>
                May’s Non-Farm Payrolls beat +13k with +139k print, but 95k revisions down and household employment collapsed –625k. Labour force participation dropped, and the unemployment rate held
                to 4.2% just on round down. It could have been much worse if those missing workers had signed on for claims. The Fed won’t love this divergence.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image66}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image66)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Services ISM slipped back below 50. New orders cratered. Prices paid spiked. This isn’t disinflation—it’s stagflation risk</p>
              <div className="relatedImg">
                <img
                  src={image36}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image36)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Central banks globally are easing: the ECB cut 25bps, Denmark followed, and China posted its fourth consecutive deflationary month. Add stealth gold buying by EM CBs, and the case for
                global liquidity grows.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image32}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image32)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Also note: U.S. housing is decelerating—Household debt rose +$ 212 B last quarter but Supply gapping above demand. GDPNow estimates for Q2 are now tracking +3.1%.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image43}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image43)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                And Trump’s tariff poker isn’t over: capital controls are being floated again, and investors should be watching for Section 899 fallout for the dollar if foreign holdings see extra
                taxes. Trump is unruffled.
              </p>
              <div className="relatedImg">
                <img
                  src={image2}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image2)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Setups: “Breadth Is Real—and Still Flow-Fueled”</p>
              <p>
                Internals suggest this breakout is for real rather than worries that April's was retail dip buying . Credit spreads tightened, SMID-caps outperformed, and new sector leadership
                emerged.
              </p>
              <div className="relatedImg">
                <img
                  src={image17}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image17)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Gold’s breakout structure is intact. ETF inflows still suggest a record year, and undeclared accumulation continues beneath the surface. Silver is finally participating—watch the ratio
                shift…silver usually o/p in mature gold rallies
              </p>
              <div className="relatedImg">
                <img
                  src={image33}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image33)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Oil hit a 1.5-month high after bullish EIA/API surprises and China optimism. But weak demand, refinery margins, and inventories still cap upside.</p>
              <div className="relatedImg">
                <img
                  src={image35}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image35)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Even BTC showed macro rotation signals last week as it tracked gold on weak-dollar themes and EM accumulation. Funny how mainstream it has become…</p>
              <div className="relatedImg">
                <img
                  src={image34}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image34)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Sentiment is neutral, not euphoric. That’s an interesting middle ground. Positioning is no longer a tailwind but not yet a headwind either.</p>
              <hr className="divisionLine" />
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week in Review: “Flows Up, Data Soft, Internals Strengthen”</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX, Dow, and Russell closed at 3.5-month highs</p>
                </li>
                <li className="themesPointer">
                  <p>Nasdaq gained +2%, Russell +3.19%</p>
                </li>
                <li className="themesPointer">
                  <p>MAG7 rotated, AI/chips rebounded</p>
                </li>
                <li className="themesPointer">
                  <p>China resumed rare earth shipments</p>
                </li>
                <li className="themesPointer">
                  <p>ISM Services {"<"}50, NFP mixed</p>
                </li>
                <li className="themesPointer">
                  <p>CTA flows stayed long, hedge funds turned buyers into Thursday</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image66}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image66)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Gold was flat despite quiet accumulation. Oil up 3%. USD stable. MOVE drifted down. This wasn’t a “growth” week—it was a “liquidity plus positioning” week. Dips were bought by the pros
                this time.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Week Ahead: “CPI, PPI, Auctions, and Apple’s AI Reboot”</p>
              <p>Each day this week holds critical macro risk but no Fed speakers (in lockdown):</p>
              <p className="highlightedText">Monday, June 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China trade talks resume in London</p>
                </li>
                <li className="themesPointer">
                  <p>Rare earth shipping deadline suggested to be positive result</p>
                </li>
                <li className="themesPointer">
                  <p>China in deflation and exports to US cratering</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image40}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image40)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Tuesday, June 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>NFIB Small Business Optimism</p>
                </li>
                <li className="themesPointer">
                  <p>3Y Treasury Auction</p>
                </li>
                <li className="themesPointer">
                  <p>Trump expected remarks on tariffs/capital flows all week</p>
                </li>
                <li className="themesPointer">
                  <p>CPI front-run begins</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, June 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CPI report (first with tariff pass-through)</p>
                </li>
                <li className="themesPointer">
                  <p>Core expected +0.3% MoM</p>
                </li>
                <li className="themesPointer">
                  <p>Headline YoY expected 2.5%</p>
                  <div className="subpointers">
                    <p>• 10Y Treasury Auction</p>
                    <p>• Apple WWDC25 continues 9th-13th, AI roadmap & chip integration</p>
                  </div>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image42}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image42)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Thursday, June 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>PPI Report</p>
                </li>
                <li className="themesPointer">
                  <p>30Y Treasury Auction</p>
                </li>
                <li className="themesPointer">
                  <p>UK GDP</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Schnabel & De Guindos speak</p>
                </li>
                <li className="themesPointer">
                  <p>Gold and silver could move if PPI low like in Europe</p>
                </li>
              </ul>
              <p className="highlightedText">Friday, June 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Univ. of Michigan Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>1Y / 5Y inflation expectations</p>
                </li>
                <li className="themesPointer">
                  <p>EZ Trade Balance may poke Trump</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image41}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image41)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: “Breakout Confirmed, But CPI Will Pick the Path”</p>
              <p>
                Positioning has normalised, breadth is real, and volatility is subdued. But this market is still driven by liquidity and optimism, with some earnings strength but doubted macro
                strength. CPI and trade headlines will decide whether this is the real breakout or just a final squeeze.
              </p>

              <p className="highlightedText">Key signals to monitor:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX {">"} 6000 = upside momentum</p>
                </li>
                <li className="themesPointer">
                  <p>CPI {">"} 0.4% = bond selloff, risk-off</p>
                </li>
                <li className="themesPointer">
                  <p>Trade fails = semis and EM roll over</p>
                </li>
                <li className="themesPointer">
                  <p>{"Gold > $3,400 = reflation + policy pivot bets"}</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image59}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image59)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image30}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image30)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>We’re in a narrow volatility corridor—but one macro miss can break it. Stay nimble.</p>
            </div>
          </div>
        </div>

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1bPNsn9hbH9sXh6p302Jg-Fkvc4S9sAv4egz7SdIBZFc/edit?usp=sharing");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog22;
